import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  CIRCLEONE_TEAM,
  CIRCLEONE_USER,
  CIRCLEONE_USERNAME,
} from "../../constants";
import { ReactComponent as SocialMediaIcon } from "./apps.svg";
import "./HeaderContent.css";
import { useUpgradeModal } from "../../context/UpgradeModalContext";

const styles: any = {
  menuItem: {
    padding: "12px 16px",
    fontSize: "15px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.2s ease",
    color: "#212529",
    textDecoration: "none",
    borderRadius: "6px",
    marginBottom: "4px",
  },
  menuItemActive: {
    backgroundColor: "#f1f3f5",
    color: "#6366f1",
    fontWeight: 600,
  },
  menuItemHover: {
    backgroundColor: "#f8f9fa",
  },
  menuItemDisabled: {
    color: "#6c757d",
    backgroundColor: "transparent",
    cursor: "not-allowed",
    opacity: 0.65,
  },
  dropdownItem: {
    padding: "10px 10px",
    fontSize: "15px",
    cursor: "pointer",
    color: "#212529",
    transition: "all 0.2s ease",
    display: "block",
    textDecoration: "none",
  },
  dropdownItemActive: {
    backgroundColor: "#f1f3f5",
    color: "#6366f1",
    fontWeight: 600,
  },
  dropdownItemDisabled: {
    color: "#6c757d",
    cursor: "default",
  },
  submenuContainer: {
    paddingLeft: "20px",
    overflow: "hidden",
    transition: "all 0.3s ease",
  },
  icon: {
    fontSize: "20px",
    marginRight: "12px",
    color: "#212529",
  },
  chevron: {
    fontSize: "14px",
    transition: "transform 0.3s ease",
    color: "#5a5a5a",
  },
};

const MobileHeaderContents = ({ collapsed }) => {
  const [permissionList, setPermissionList] = useState<any>([]);
  const [modulePermission, setModulePermission] = useState<boolean>(false);
  const [submenuVisible, setSubmenuVisible] = useState({});
  const [hasPhonePermission, setHasPhonePermission] = useState<boolean>(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const permissionToShow = localStorage.getItem("user-token");
  const { openUpgradeModal } = useUpgradeModal();

  const checkTenant = localStorage.getItem(CIRCLEONE_USER);
  const checkTeam = localStorage.getItem(CIRCLEONE_TEAM);
  const checkUsername = localStorage.getItem(CIRCLEONE_USERNAME);
  const isAdmin = localStorage.getItem("user_role");
  const planName = localStorage.getItem("planName") || "";


  const isFreeOrFreemium =
    planName === "Free" || planName === "Freemium";
  useEffect(() => {
    if (permissionToShow) {
      const parsedPermission = JSON.parse(permissionToShow);
      const teamPermissions = parsedPermission?.teams[0];

      const dynamicKey =
        Object.keys(teamPermissions).find((key) =>
          key.includes("module_permissions")
        ) || Object.keys(teamPermissions)[0];
      const dynamicKey1 =
        Object.keys(teamPermissions).find(
          (key) => key === "module_permissions"
        ) || Object.keys(teamPermissions)[0];
      if (dynamicKey1 === "module_permissions") {
        setModulePermission(true);
      } else {
        setModulePermission(false);
      }
      const permissionListValue = teamPermissions[dynamicKey] || [];
      setPermissionList(permissionListValue);

      // Set phone permission state
      const hasPhone = Array.isArray(permissionListValue) && permissionListValue.includes("phone:enable");
      setHasPhonePermission(hasPhone);
    }
  }, [permissionToShow]);

  const hasPermission = (permission) =>
    Array.isArray(permissionList) && permissionList.includes(permission);

  const restricteduser =
    checkTeam === "Botgo" && checkUsername === "vivek@gtbotgo.io";

  const handleSubmenuToggle = (menuKey) => {
    setSubmenuVisible((prev) => ({ ...prev, [menuKey]: !prev[menuKey] }));
  };

  const getMenuItemStyle = (isActive, isDisabled = false) => {
    if (isDisabled) {
      return { ...styles.menuItem, ...styles.menuItemDisabled };
    }
    return {
      ...styles.menuItem,
      ...(isActive ? styles.menuItemActive : {}),
    };
  };

  const getDropdownItemStyle = (isActive, isDisabled = false) => {
    if (isDisabled) {
      return { ...styles.dropdownItem, ...styles.dropdownItemDisabled };
    }
    return {
      ...styles.dropdownItem,
      ...(isActive ? styles.dropdownItemActive : {}),
    };
  };

  return (
    <div
      style={{
        padding: "16px 12px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >

      {!isFreeOrFreemium ? (
        <>

          {hasPermission("dashboard:enable") && (
            <div>
              <div
                onClick={() => handleSubmenuToggle("dashboard")}
                style={getMenuItemStyle(currentPath.includes("/dashboard"))}
                data-active={(currentPath === "/dashboard/email-dashboard" || currentPath === "/dashboard/ticket-dashboard" || currentPath === "/dashboard/campaign-dashboard" || currentPath === "/dashboard/rtm-dashboard" || currentPath === "/dashboard/conversation-dashboard") ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                  if (collapsed) {
                    const tooltip = document.createElement("div");
                    tooltip.className = "custom-tooltip";
                    tooltip.innerText = "Dashboard";
                    document.body.appendChild(tooltip);
                    const rect = e.currentTarget.getBoundingClientRect();
                    tooltip.style.left = `${rect.right + 8}px`;
                    tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                  const tooltip = document.querySelector(".custom-tooltip");
                  if (tooltip) tooltip.remove();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bi bi-house-door" style={styles.icon}></i>
                  {!collapsed && <span>Dashboard</span>}
                </div>
                {!collapsed && (
                  <i
                    className={`bi ${submenuVisible["dashboard"]
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                      }`}
                    style={styles.chevron}
                  />
                )}
              </div>

              {!collapsed && (
                <div
                  style={{
                    ...styles.submenuContainer,
                    maxHeight: submenuVisible["dashboard"] ? "500px" : "0",
                    opacity: submenuVisible["dashboard"] ? 1 : 0,
                  }}
                >
                  {!restricteduser && (
                    <>
                      <Link
                        to="/dashboard/email-dashboard"
                        style={getDropdownItemStyle(
                          currentPath === "/dashboard/email-dashboard"
                        )}
                        data-active={currentPath === "/dashboard/email-dashboard" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        Email
                      </Link>
                      <Link
                        to="/dashboard/ticket-dashboard"
                        style={getDropdownItemStyle(
                          currentPath === "/dashboard/ticket-dashboard"
                        )}
                        data-active={currentPath === "/dashboard/ticket-dashboard" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        Ticket
                      </Link>
                    </>
                  )}
                  {["victorinox", "mdindia"].includes(checkTenant) ? (
                    <div style={getDropdownItemStyle(false, true)}>Whatsapp</div>
                  ) : (
                    <Link
                      to="/dashboard/campaign-dashboard"
                      style={getDropdownItemStyle(
                        currentPath === "/dashboard/campaign-dashboard"
                      )}
                      data-active={currentPath === "/dashboard/campaign-dashboard" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Whatsapp
                    </Link>
                  )}

                  
                  {["victorinox", "knabfinance", "mdindia", "cslfinance", "cloudtelephony"].includes(
                    checkTenant
                  ) ? (
                    <div style={getDropdownItemStyle(false, true)}>Telephony</div>
                  ) : (
                 ((isAdmin === "admin" || isAdmin === "manager") && hasPhonePermission) && (
                    <Link
                      to="/dashboard/rtm-dashboard"
                      style={getDropdownItemStyle(
                        currentPath === "/dashboard/rtm-dashboard"
                      )}
                      data-active={currentPath === "/dashboard/rtm-dashboard" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Telephony
                    </Link>
                  )
                  )}
                  {["stage", "globtier2", "botgo", "raptee", "meta"].includes(
                    checkTenant
                  ) ? (
                    <Link
                      to="/dashboard/conversation-dashboard"
                      style={getDropdownItemStyle(
                        currentPath === "/dashboard/conversation-dashboard"
                      )}
                      data-active={currentPath === "/dashboard/conversation-dashboard" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Chat
                    </Link>
                  ) : (
                    <div style={getDropdownItemStyle(false, true)}>Chat</div>
                  )}

                      <Link
                        to="/dashboard/lead-dashboard"
                        style={getDropdownItemStyle(
                          currentPath === "/dashboard/lead-dashboard"
                        )}
                        data-active={currentPath === "/dashboard/lead-dashboard" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        Lead
                      </Link>
                </div>
              )}
            </div>
          )}

          {/* Activity */}
          {!restricteduser && (
            <div>
              <div
                onClick={() => handleSubmenuToggle("activity")}
                style={getMenuItemStyle(currentPath.includes("/activity"))}
                data-active={(currentPath === "/activity/active" || currentPath === "/activity/recent" || currentPath === "/activity/unassigned") ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                  if (collapsed) {
                    const tooltip = document.createElement("div");
                    tooltip.className = "custom-tooltip";
                    tooltip.innerText = "Activity";
                    document.body.appendChild(tooltip);
                    const rect = e.currentTarget.getBoundingClientRect();
                    tooltip.style.left = `${rect.right + 8}px`;
                    tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                  const tooltip = document.querySelector(".custom-tooltip");
                  if (tooltip) tooltip.remove();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bi bi-activity" style={styles.icon}></i>
                  {!collapsed && <span>Activity</span>}
                </div>
                {!collapsed && (
                  <i
                    className={`bi ${submenuVisible["activity"]
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                      }`}
                    style={styles.chevron}
                  />
                )}
              </div>

              {!collapsed && (
                <div
                  style={{
                    ...styles.submenuContainer,
                    maxHeight: submenuVisible["activity"] ? "300px" : "0",
                    opacity: submenuVisible["activity"] ? 1 : 0,
                  }}
                >
                  <Link
                    to="/activity/active"
                    style={getDropdownItemStyle(currentPath === "/activity/active")}
                    data-active={currentPath === "/activity/active" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Today
                  </Link>
                  <Link
                    to="/activity/recent"
                    style={getDropdownItemStyle(currentPath === "/activity/recent")}
                    data-active={currentPath === "/activity/recent" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Recent
                  </Link>
                  <Link
                    to="/activity/unassigned"
                    style={getDropdownItemStyle(
                      currentPath === "/activity/unassigned"
                    )}
                    data-active={currentPath === "/activity/unassigned" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Unassigned
                  </Link>
                  <Link
                    to="/activity/sl-breached"
                    style={getDropdownItemStyle(
                      currentPath === "/activity/sl-breached"
                    )}
                    data-active={currentPath === "/activity/sl-breached" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    SL Breached
                  </Link>

                </div>
              )}
            </div>
          )}

          {/* Users */}
          {hasPermission("users:enable") && (
            <Link
              to="/users/user"
              style={getMenuItemStyle(currentPath === "/users/user")}
              data-active={currentPath === "/users/user" ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Users";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-people" style={styles.icon}></i>
                {!collapsed && <span>Users</span>}
              </div>
            </Link>
          )}

          {/* Customer */}
          {hasPermission("customers:enable") && (
            <div>
              <div
                onClick={() => handleSubmenuToggle("customer")}
                style={getMenuItemStyle(currentPath === "/contact/customer/account" || currentPath === "/contact/customer/contact")}
                data-active={(currentPath === "/contact/customer/account" || currentPath === "/contact/customer/contact") ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                  if (collapsed) {
                    const tooltip = document.createElement("div");
                    tooltip.className = "custom-tooltip";
                    tooltip.innerText = "Customer";
                    document.body.appendChild(tooltip);
                    const rect = e.currentTarget.getBoundingClientRect();
                    tooltip.style.left = `${rect.right + 8}px`;
                    tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                  const tooltip = document.querySelector(".custom-tooltip");
                  if (tooltip) tooltip.remove();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bi bi-person" style={styles.icon}></i>
                  {!collapsed && <span>Customer</span>}
                </div>
                {!collapsed && (
                  <i
                    className={`bi ${submenuVisible["customer"]
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                      }`}
                    style={styles.chevron}
                  />
                )}
              </div>
              {!collapsed && (
                <div
                  style={{
                    ...styles.submenuContainer,
                    maxHeight: submenuVisible["customer"] ? "200px" : "0",
                    opacity: submenuVisible["customer"] ? 1 : 0,
                  }}
                >
                  <Link
                    to="/contact/customer/contact"
                    style={getDropdownItemStyle(currentPath === "/contact/customer/contact")}
                    data-active={currentPath === "/contact/customer/contact" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Contact
                  </Link>
                  <Link
                    to="/contact/customer/account"
                    style={getDropdownItemStyle(currentPath === "/contact/customer/account")}
                    data-active={currentPath === "/contact/customer/account" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Account
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* Email */}
          {!restricteduser && hasPermission("email:enable") && (
            <Link
              to="/email/inbox"
              style={getMenuItemStyle(currentPath === "/email/inbox")}
              data-active={currentPath === "/email/inbox" ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Email";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-envelope-arrow-down" style={styles.icon}></i>
                {!collapsed && <span>Email</span>}
              </div>
            </Link>
          )}

          {/* Ticket */}
          {!restricteduser && hasPermission("ticket:enable") && (
            <Link
              to="/ticket/lists"
              style={getMenuItemStyle(currentPath === "/ticket/lists")}
              data-active={currentPath === "/ticket/lists" ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Ticket";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-ticket-detailed" style={styles.icon}></i>
                {!collapsed && <span>Ticket</span>}
              </div>
            </Link>
          )}

          {/* Leads/Campaign */}
          {hasPermission("campaigns:enable") && (
            <>
              {["victorinox", "mdindia"].includes(checkTenant) ? (
                <div style={getMenuItemStyle(false, true)}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <i className="bi bi-menu-up" style={styles.icon}></i>
                    {!collapsed && <span>Leads</span>}
                  </div>
                </div>
              ) : (
                <Link
                  to="/campaign/list"
                  style={getMenuItemStyle(currentPath === "/campaign/list")}
                  data-active={currentPath === "/campaign/list" ? "true" : ""}
                  onMouseEnter={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }
                    if (collapsed) {
                      const tooltip = document.createElement("div");
                      tooltip.className = "custom-tooltip";
                      tooltip.innerText = "Leads";
                      document.body.appendChild(tooltip);
                      const rect = e.currentTarget.getBoundingClientRect();
                      tooltip.style.left = `${rect.right + 8}px`;
                      tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "";
                    }
                    const tooltip = document.querySelector(".custom-tooltip");
                    if (tooltip) tooltip.remove();
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <i className="bi bi-menu-up" style={styles.icon}></i>
                    {!collapsed && <span>Leads</span>}
                  </div>
                </Link>
              )}
            </>
          )}

          {/* Chat */}
          <div>
            <div
              onClick={() =>
                !["victorinox", "mdindia", "knabfinance"].includes(checkTenant) &&
                handleSubmenuToggle("chat")
              }
              style={getMenuItemStyle(
                currentPath.includes("/chat"),
                ["victorinox", "mdindia", "knabfinance"].includes(checkTenant)
              )}
              data-active={currentPath === "/chat/chatrooms" ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Chat";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-chat" style={styles.icon}></i>
                {!collapsed && <span>Chat</span>}
              </div>
              {!collapsed &&
                !["victorinox", "mdindia", "knabfinance"].includes(checkTenant) && (
                  <i
                    className={`bi ${submenuVisible["chat"] ? "bi-chevron-up" : "bi-chevron-down"
                      }`}
                    style={styles.chevron}
                  />
                )}
            </div>

            {!collapsed &&
              !["victorinox", "mdindia", "knabfinance"].includes(checkTenant) && (
                <div
                  style={{
                    ...styles.submenuContainer,
                    maxHeight: submenuVisible["chat"] ? "200px" : "0",
                    opacity: submenuVisible["chat"] ? 1 : 0,
                  }}
                >
                  <Link
                    to="/chat/chatrooms?type=Assigned"
                    style={getDropdownItemStyle(
                      currentPath.includes("/chat/chatrooms") &&
                      new URLSearchParams(window.location.search).get("type") ===
                      "Assigned"
                    )}
                    data-active={currentPath === "/chat/chatrooms" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Live Chat
                  </Link>
                  <Link
                    to="/chat/chatrooms?type=Resolved"
                    style={getDropdownItemStyle(
                      currentPath.includes("/chat/chatrooms") &&
                      new URLSearchParams(window.location.search).get("type") ===
                      "Resolved"
                    )}
                    data-active={currentPath === "/chat/chatrooms" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Chat history
                  </Link>
                </div>
              )}
          </div>

          {/* Social Media */}
          {(checkTenant === "meta" ||
            checkTenant === "stage" ||
            checkTenant === "raptee") && (
              <div>
                <div
                  onClick={() => handleSubmenuToggle("socialMedia")}
                  style={getMenuItemStyle(currentPath.includes("/social-media"))}
                  data-active={(currentPath === "/social-media/youtube" || currentPath === "/social-media/instagram" || currentPath === "/social-media/post") ? "true" : ""}
                  onMouseEnter={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }
                    if (collapsed) {
                      const tooltip = document.createElement("div");
                      tooltip.className = "custom-tooltip";
                      tooltip.innerText = "Social Media";
                      document.body.appendChild(tooltip);
                      const rect = e.currentTarget.getBoundingClientRect();
                      tooltip.style.left = `${rect.right + 8}px`;
                      tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "";
                    }
                    const tooltip = document.querySelector(".custom-tooltip");
                    if (tooltip) tooltip.remove();
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <SocialMediaIcon
                      style={{ width: 20, height: 20, marginRight: 12 }}
                    />
                    {!collapsed && <span>Social Media</span>}
                  </div>
                  {!collapsed && (
                    <i
                      className={`bi ${submenuVisible["socialMedia"]
                        ? "bi-chevron-up"
                        : "bi-chevron-down"
                        }`}
                      style={styles.chevron}
                    />
                  )}
                </div>

                {!collapsed && (
                  <div
                    style={{
                      ...styles.submenuContainer,
                      maxHeight: submenuVisible["socialMedia"] ? "300px" : "0",
                      opacity: submenuVisible["socialMedia"] ? 1 : 0,
                    }}
                  >
                    <Link
                      to="/social-media/youtube"
                      style={getDropdownItemStyle(
                        currentPath === "/social-media/youtube"
                      )}
                      data-active={currentPath === "/social-media/youtube" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Youtube
                    </Link>
                    <Link
                      to="/social-media/instagram"
                      style={getDropdownItemStyle(
                        currentPath === "/social-media/instagram"
                      )}
                      data-active={currentPath === "/social-media/instagram" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Instagram
                    </Link>
                    <Link
                      to="/social-media/post"
                      style={getDropdownItemStyle(
                        currentPath === "/social-media/post"
                      )}
                      data-active={currentPath === "/social-media/post" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Post
                    </Link>
                  </div>
                )}
              </div>
            )}

          {/* Reports */}
          {hasPermission("reports:enable") && (
            <div>
              <div
                onClick={() => handleSubmenuToggle("reports")}
                style={getMenuItemStyle(currentPath.includes("/reports"))}
                data-active={(currentPath === "/reports/campaign/reports-list" || currentPath === "/reports/email/reports-list" || currentPath === "/reports/ticket/reports-list" || currentPath === "/reports/telephony/reports-list" || currentPath === "/reports/report-social-media/reports-list" || currentPath === "/reports/conversation/conversationHistory-report") ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                  if (collapsed) {
                    const tooltip = document.createElement("div");
                    tooltip.className = "custom-tooltip";
                    tooltip.innerText = "Reports";
                    document.body.appendChild(tooltip);
                    const rect = e.currentTarget.getBoundingClientRect();
                    tooltip.style.left = `${rect.right + 8}px`;
                    tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                  const tooltip = document.querySelector(".custom-tooltip");
                  if (tooltip) tooltip.remove();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i
                    className="bi bi-file-earmark-bar-graph"
                    style={styles.icon}
                  ></i>
                  {!collapsed && <span>Reports</span>}
                </div>
                {!collapsed && (
                  <i
                    className={`bi ${submenuVisible["reports"]
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                      }`}
                    style={styles.chevron}
                  />
                )}
              </div>

              {!collapsed && (
                <div
                  style={{
                    ...styles.submenuContainer,
                    maxHeight: submenuVisible["reports"] ? "500px" : "0",
                    opacity: submenuVisible["reports"] ? 1 : 0,
                  }}
                >
                  {(checkTenant === "mdindia" || checkTenant === "stage" || checkTenant === "victorinox" || checkTenant === "cslfinance" || checkTenant === "knabfinance" || checkTenant === "mdindiadcinvoice"  || checkTenant === "csquare"  || checkTenant === "payswiffibl" || checkTenant === "payswiffstage" || checkTenant === "briezi" ) && (
                  <Link
                    to="/reports/downloader"
                    style={getDropdownItemStyle(
                      currentPath.startsWith("/reports/downloader")
                    )}
                    data-active={
                      currentPath.startsWith("/reports/downloader") ? "true" : ""
                    }
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Exported Report
                  </Link>
                  )}
                  {restricteduser ? (
                    <Link
                      to="/reports/campaign/reports-list"
                      style={getDropdownItemStyle(
                        currentPath === "/reports/campaign/reports-list"
                      )}
                      data-active={currentPath === "/reports/campaign/reports-list" ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      Leads
                    </Link>
                  ) : (
                    <>
                      <Link
                        to="/reports/email/reports-list"
                        style={getDropdownItemStyle(
                          currentPath === "/reports/email/reports-list",

                        )}
                        data-active={currentPath === "/reports/email/reports-list" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        Email
                      </Link>
                      <Link
                        to="/reports/ticket/reports-list"
                        style={getDropdownItemStyle(
                          currentPath === "/reports/ticket/reports-list"
                        )}
                        data-active={currentPath === "/reports/ticket/reports-list" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        Ticket
                      </Link>
                      {["victorinox", "mdindia", "cloudtelephony", "cslfinance"].includes(checkTenant) ? (
                        <div style={getDropdownItemStyle(false, true)}>
                          Telephony
                        </div>
                      ) : (
                        <Link
                          to="/reports/telephony/reports-list"
                          style={getDropdownItemStyle(
                            currentPath === "/reports/telephony/reports-list"
                          )}
                          data-active={currentPath === "/reports/telephony/reports-list" ? "true" : ""}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "#f1f3f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          Telephony
                        </Link>
                      )}
                      {["victorinox", "mdindia"].includes(checkTenant) ? (
                        <div style={getDropdownItemStyle(false, true)}>Leads</div>
                      ) : (
                        <Link
                          to="/reports/campaign/reports-list"
                          style={getDropdownItemStyle(
                            currentPath === "/reports/campaign/reports-list"
                          )}
                          data-active={currentPath === "/reports/campaign/reports-list" ? "true" : ""}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "#f1f3f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          Leads
                        </Link>
                      )}
                      {checkTenant !== "stage" &&
                        checkTenant !== "meta" &&
                        checkTenant !== "globtier2" &&
                        checkTenant !== "botgo" &&
                        checkTenant !== "raptee" ? (
                        <div style={getDropdownItemStyle(false, true)}>Chat</div>
                      ) : (
                        <Link
                          to="/reports/conversation/conversationHistory-report"
                          style={getDropdownItemStyle(
                            currentPath ===
                            "/reports/conversation/conversationHistory-report"
                          )}
                          data-active={currentPath === "/reports/conversation/conversationHistory-report" ? "true" : ""}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "#f1f3f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          Chat
                        </Link>
                      )}
                      {["meta", "stage", "raptee", "globtier2"].includes(
                        checkTenant
                      ) ? (
                        <Link
                          to="/reports/report-social-media/reports-list"
                          style={getDropdownItemStyle(
                            currentPath ===
                            "/reports/report-social-media/reports-list"
                          )}
                          data-active={currentPath === "/reports/report-social-media/reports-list" ? "true" : ""}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "#f1f3f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          Social media
                        </Link>
                      ) : (
                        <div style={getDropdownItemStyle(false, true)}>
                          Social media
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Settings */}
          {hasPermission("settings:enable") && (
            <div>
              <div
                onClick={() => handleSubmenuToggle("settings")}
                style={getMenuItemStyle(currentPath.includes("/settings"))}
                data-active={(currentPath === "/settings/users" || currentPath === "/settings/customer" || currentPath === "/settings/general" || currentPath === "/settings/ticket" || currentPath === "/settings/email" || currentPath === "/settings/campaign" || currentPath === "/settings/telephony/server-configuration" || currentPath === "/settings/integration" || currentPath === "/settings/youtube" || currentPath === "/settings/instagram-config" || currentPath === "/settings/youtubebot" || currentPath === "/settings/website" || currentPath === "/settings/instagram" || currentPath === "/settings/chat" || currentPath === "/settings/schedule" || currentPath === "/settings/acknowledgement") ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                  if (collapsed) {
                    const tooltip = document.createElement("div");
                    tooltip.className = "custom-tooltip";
                    tooltip.innerText = "Settings";
                    document.body.appendChild(tooltip);
                    const rect = e.currentTarget.getBoundingClientRect();
                    tooltip.style.left = `${rect.right + 8}px`;
                    tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                  const tooltip = document.querySelector(".custom-tooltip");
                  if (tooltip) tooltip.remove();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bi bi-sliders" style={styles.icon}></i>
                  {!collapsed && <span>Settings</span>}
                </div>
                {!collapsed && (
                  <i
                    className={`bi ${submenuVisible["settings"]
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                      }`}
                    style={styles.chevron}
                  />
                )}
              </div>

              {!collapsed && (
                <div
                  style={{
                    ...styles.submenuContainer,
                    maxHeight: submenuVisible["settings"] ? "800px" : "0",
                    opacity: submenuVisible["settings"] ? 1 : 0,
                  }}
                >
                  <Link
                    to="/settings/users"
                    style={getDropdownItemStyle(currentPath === "/settings/users")}
                    data-active={currentPath === "/settings/users" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-people-fill"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Users
                  </Link>
                  <Link
                    to="/settings/customer"
                    style={getDropdownItemStyle(
                      currentPath === "/settings/customer"
                    )}
                    data-active={currentPath === "/settings/customer" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-bag-check-fill"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Contact
                  </Link>
                  <Link
                    to="/settings/general"
                    style={getDropdownItemStyle(
                      currentPath === "/settings/general"
                    )}
                    data-active={currentPath === "/settings/general" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-sliders"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    General
                  </Link>
                  <Link
                    to="/settings/ticket"
                    style={getDropdownItemStyle(currentPath === "/settings/ticket")}
                    data-active={currentPath === "/settings/ticket" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-ticket-detailed"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Ticket
                  </Link>
                  <Link
                    to="/settings/email"
                    style={getDropdownItemStyle(currentPath === "/settings/email")}
                    data-active={currentPath === "/settings/email" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-envelope"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Email
                  </Link>
                  <Link
                    to="/settings/campaign"
                    style={getDropdownItemStyle(
                      currentPath === "/settings/campaign"
                    )}
                    data-active={currentPath === "/settings/campaign" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-menu-up"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Leads
                  </Link>
                  <Link
                    to="/settings/telephony/server-configuration"
                    style={getDropdownItemStyle(
                      currentPath.includes("/settings/telephony/server-configuration")
                    )}
                    data-active={currentPath === "/settings/telephony/server-configuration" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-telephone"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Telephony
                  </Link>

                  {/* Social Media Nested Submenu */}
                  <div>
                    <div
                      onClick={() => handleSubmenuToggle("settingsSocialMedia")}
                      style={{
                        ...getDropdownItemStyle(
                          currentPath.includes("/settings/integration") ||
                          currentPath.includes("/settings/youtube") ||
                          currentPath.includes("/settings/instagram-config") ||
                          currentPath.includes("/settings/website") ||
                          currentPath.includes("/settings/instagram") ||
                          currentPath.includes("/settings/youtubebot")
                        ),
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      data-active={(currentPath === "/settings/integration" || currentPath === "/settings/youtube" || currentPath === "/settings/instagram-config" || currentPath === "/settings/instagram" || currentPath === "/settings/youtubebot" || currentPath === "/settings/website") ? "true" : ""}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "#f1f3f5";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!e.currentTarget.dataset.active) {
                          e.currentTarget.style.backgroundColor = "";
                        }
                      }}
                    >
                      <span>
                        <i
                          className="bi bi-share"
                          style={{ fontSize: "14px", marginRight: "8px" }}
                        ></i>
                        Social media
                      </span>
                      <i
                        className={`bi ${submenuVisible["settingsSocialMedia"]
                          ? "bi-chevron-up"
                          : "bi-chevron-down"
                          }`}
                        style={{ ...styles.chevron, fontSize: "12px" }}
                      />
                    </div>

                    <div
                      style={{
                        paddingLeft: "30px",
                        overflow: "hidden",
                        transition: "all 0.3s ease",
                        maxHeight: submenuVisible["settingsSocialMedia"]
                          ? "600px"
                          : "0",
                        opacity: submenuVisible["settingsSocialMedia"] ? 1 : 0,
                      }}
                    >
                      <Link
                        to="/settings/integration"
                        style={getDropdownItemStyle(
                          currentPath === "/settings/integration"
                        )}
                        data-active={currentPath === "/settings/integration" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        <i
                          className="bi bi-gear"
                          style={{ fontSize: "13px", marginRight: "8px" }}
                        ></i>
                        WhatsApp configuration
                      </Link>
                      <Link
                        to="/settings/youtube"
                        style={getDropdownItemStyle(
                          currentPath === "/settings/youtube"
                        )}
                        data-active={currentPath === "/settings/youtube" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        <i
                          className="bi bi-calendar-event"
                          style={{ fontSize: "13px", marginRight: "8px" }}
                        ></i>
                        Youtube configuration
                      </Link>
                      <Link
                        to="/settings/instagram-config"
                        style={getDropdownItemStyle(
                          currentPath === "/settings/instagram-config"
                        )}
                        data-active={currentPath === "/settings/instagram-config" ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        <i
                          className="bi bi-instagram"
                          style={{ fontSize: "13px", marginRight: "8px" }}
                        ></i>
                        Instagram configuration
                      </Link>

                      {/* Bot Configuration Nested Submenu */}
                      <div>
                        <div
                          onClick={() => handleSubmenuToggle("settingsBotConfig")}
                          style={{
                            ...getDropdownItemStyle(
                              currentPath === "/settings/instagram" ||
                              currentPath.includes("/settings/website") ||
                              currentPath.includes("/settings/youtubebot")
                            ),
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontSize: "14px",
                          }}
                          data-active={(currentPath === "/settings/instagram" || currentPath === "/settings/youtubebot" || currentPath === "/settings/website") ? "true" : ""}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "#f1f3f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.dataset.active) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          <span>
                            <i
                              className="bi bi-robot"
                              style={{ fontSize: "13px", marginRight: "8px" }}
                            ></i>
                            Bot configuration
                          </span>
                          <i
                            className={`bi ${submenuVisible["settingsBotConfig"]
                              ? "bi-chevron-up"
                              : "bi-chevron-down"
                              }`}
                            style={{ ...styles.chevron, fontSize: "11px" }}
                          />
                        </div>

                        <div
                          style={{
                            paddingLeft: "30px",
                            overflow: "hidden",
                            transition: "all 0.3s ease",
                            maxHeight: submenuVisible["settingsBotConfig"]
                              ? "300px"
                              : "0",
                            opacity: submenuVisible["settingsBotConfig"] ? 1 : 0,
                          }}
                        >
                          <Link
                            to="/settings/instagram"
                            style={getDropdownItemStyle(
                              currentPath === "/settings/instagram"
                            )}
                            data-active={currentPath === "/settings/instagram" ? "true" : ""}
                            onMouseEnter={(e) => {
                              if (!e.currentTarget.dataset.active) {
                                e.currentTarget.style.backgroundColor = "#f1f3f5";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!e.currentTarget.dataset.active) {
                                e.currentTarget.style.backgroundColor = "";
                              }
                            }}
                          >
                            <i
                              className="bi bi-instagram"
                              style={{ fontSize: "12px", marginRight: "8px" }}
                            ></i>
                            Instagram
                          </Link>
                          <Link
                            to="/settings/website"
                            style={getDropdownItemStyle(
                              currentPath === "/settings/website"
                            )}
                            data-active={currentPath === "/settings/website" ? "true" : ""}
                            onMouseEnter={(e) => {
                              if (!e.currentTarget.dataset.active) {
                                e.currentTarget.style.backgroundColor = "#f1f3f5";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!e.currentTarget.dataset.active) {
                                e.currentTarget.style.backgroundColor = "";
                              }
                            }}
                          >
                            <i
                              className="bi bi-globe"
                              style={{ fontSize: "12px", marginRight: "8px" }}
                            ></i>
                            Website
                          </Link>
                          <Link
                            to="/settings/youtubebot"
                            style={getDropdownItemStyle(
                              currentPath === "/settings/youtubebot"
                            )}
                            data-active={currentPath === "/settings/youtubebot" ? "true" : ""}
                            onMouseEnter={(e) => {
                              if (!e.currentTarget.dataset.active) {
                                e.currentTarget.style.backgroundColor = "#f1f3f5";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!e.currentTarget.dataset.active) {
                                e.currentTarget.style.backgroundColor = "";
                              }
                            }}
                          >
                            <i
                              className="bi bi-youtube"
                              style={{ fontSize: "12px", marginRight: "8px" }}
                            ></i>
                            Youtube
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Chat Settings */}
                  <Link
                    to="/settings/setting-chat"
                    style={getDropdownItemStyle(currentPath === "/settings/setting-chat")}
                    data-active={currentPath === "/settings/setting-chat" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <i
                      className="bi bi-chat-text"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    ></i>
                    Chat
                  </Link>

                  {/* Schedule Report */}
                  {/* <Link
                to="/settings/schedule"
                style={getDropdownItemStyle(
                  currentPath === "/settings/schedule"
                )}
                  data-active={currentPath === "/settings/schedule" ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                }}
              >
                <i
                  className="bi bi-clock"
                  style={{ fontSize: "14px", marginRight: "8px" }}
                ></i>
                Schedule report
              </Link> */}

                  {/* Knowledge Base */}
                  {/* <Link
                to="/settings/acknowledgement"
                style={getDropdownItemStyle(
                  currentPath === "/settings/acknowledgement"
                )}
                  data-active={currentPath === "/settings/acknowledgement" ? "true" : ""}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.dataset.active) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                }}
              >
                <i
                  className="bi bi-check-circle"
                  style={{ fontSize: "14px", marginRight: "8px" }}
                ></i>
                Knowledge base
              </Link> */}
                </div>
              )}
            </div>
          )}

        </>

      ) : (
        <>


          <div>
            <div
              onClick={() => handleSubmenuToggle("dashboard")}
              style={getMenuItemStyle(currentPath.includes("/dashboard"))}
              data-active={(currentPath === "/dashboard/email-dashboard" || currentPath === "/dashboard/ticket-dashboard" || currentPath === "/dashboard/campaign-dashboard" || currentPath === "/dashboard/rtm-dashboard" || currentPath === "/dashboard/rtm-dashboard" || currentPath === "/dashboard/conversation-dashboard") ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Dashboard";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-house-door" style={styles.icon}></i>
                {!collapsed && <span>Dashboard</span>}
              </div>
              {!collapsed && (
                <i
                  className={`bi ${submenuVisible["dashboard"]
                    ? "bi-chevron-up"
                    : "bi-chevron-down"
                    }`}
                  style={styles.chevron}
                />
              )}
            </div>

            {!collapsed && (
              <div
                style={{
                  ...styles.submenuContainer,
                  maxHeight: submenuVisible["dashboard"] ? "500px" : "0",
                  opacity: submenuVisible["dashboard"] ? 1 : 0,
                }}
              >
                {!restricteduser && (
                  <>

                    <Link
                      to="/dashboard/lead-dashboard"
                      style={{
                        ...getDropdownItemStyle(true),
                        backgroundColor: "#f1f3f5",
                        fontWeight: 500,
                        color: "#212529"
                      }}
                      data-active="true"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e9ecef";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }}
                    >
                      Lead
                    </Link>

                    <div
                      style={{
                        ...styles.dropdownItem,
                        color: "#adb5bd",
                        cursor: "not-allowed",
                        padding: "8px 16px"
                      }}
                      onClick={() => openUpgradeModal()}
                    >
                      Email
                    </div>
                    <div
                      style={{
                        ...styles.dropdownItem,
                        color: "#adb5bd",
                        cursor: "not-allowed",
                        padding: "8px 16px"
                      }}
                      onClick={() => openUpgradeModal()}
                    >
                      Ticket
                    </div>
                    {checkTenant === "victorinox" ? (
                      <div
                        style={{
                          ...styles.dropdownItem,
                          color: "#adb5bd",
                          cursor: "not-allowed",
                        }}
                        onClick={() => openUpgradeModal()}
                      >
                        Whatsapp
                      </div>
                    ) : (
                      <div
                        style={{
                          ...styles.dropdownItem,
                          color: "#adb5bd",
                          cursor: "not-allowed",
                          padding: "8px 16px"
                        }}
                        onClick={() => openUpgradeModal()}
                      >
                        Whatsapp
                      </div>
                    )}
                    {!restricteduser && (
                      <>
                        {checkTenant === "victorinox" ? (
                          <div
                            style={{
                              ...styles.dropdownItem,
                              color: "#adb5bd",
                              cursor: "not-allowed",
                            }}
                            onClick={() => openUpgradeModal()}
                          >
                            Telephony
                          </div>
                        ) : (
                          <div
                            style={{
                              ...styles.dropdownItem,
                              color: "#adb5bd",
                              cursor: "not-allowed",
                              padding: "8px 16px"
                            }}
                            onClick={() => openUpgradeModal()}
                          >
                            Telephony
                          </div>
                        )}
                        {checkTenant === "victorinox" ? (
                          <div
                            style={{
                              ...styles.dropdownItem,
                              color: "#adb5bd",
                              cursor: "not-allowed",
                            }}
                            onClick={() => openUpgradeModal()}
                          >
                            Chat Dashboard
                          </div>
                        ) : (
                          <div
                            style={{
                              ...styles.dropdownItem,
                              color: "#adb5bd",
                              cursor: "not-allowed",
                              padding: "8px 16px"
                            }}
                            onClick={() => openUpgradeModal()}
                          >
                            Chat Dashboard
                          </div>
                        )}

                        <div
                          style={{
                            ...styles.dropdownItem,
                            color: "#adb5bd",
                            cursor: "not-allowed",
                            padding: "8px 16px"
                          }}
                          onClick={() => openUpgradeModal()}
                        >
                          Social Media
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </div>


          {/* activity */}
          <div>
            <div
              onClick={() => handleSubmenuToggle("activity")}
              style={getMenuItemStyle(currentPath.includes("/activity"))}
              data-active={(currentPath === "/activity/active" || currentPath === "/activity/recent" || currentPath === "/activity/unassigned" || currentPath === "/activity/sl-breached") ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Activity";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-activity" style={styles.icon}></i>
                {!collapsed && <span>Activity</span>}
              </div>
              {!collapsed && (
                <i
                  className={`bi ${submenuVisible["activity"]
                    ? "bi-chevron-up"
                    : "bi-chevron-down"
                    }`}
                  style={styles.chevron}
                />
              )}
            </div>

            {!collapsed && (
              <div
                style={{
                  ...styles.submenuContainer,
                  maxHeight: submenuVisible["activity"] ? "300px" : "0",
                  opacity: submenuVisible["activity"] ? 1 : 0,
                  transition: "all 0.3s ease",
                }}
              >
                {[
                  { path: "active", label: "Today" },
                  { path: "recent", label: "Recent" },
                  { path: "unassigned", label: "Unassigned" },
                  { path: "sl-breached", label: "SL Breached" }
                ].map((item) => (
                  <div
                    key={item.path}
                    onClick={(e) => {
                      if (isFreeOrFreemium) {
                        e.preventDefault();
                        e.stopPropagation();
                        openUpgradeModal();
                      }
                    }}
                    style={{
                      ...getDropdownItemStyle(currentPath === `/activity/${item.path}`),
                      ...(isFreeOrFreemium ? {
                        color: "#adb5bd",
                        cursor: "not-allowed",
                      } : {
                        cursor: "pointer"
                      })
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "";
                    }}
                  >
                    {isFreeOrFreemium ? (
                      <span>{item.label}</span>
                    ) : (
                      <Link
                        to={`/activity/${item.path}`}
                        style={{
                          display: "block",
                          width: "100%",
                          color: "inherit",
                          textDecoration: "none"
                        }}
                        onClick={(e) => {
                          // Prevent the click from bubbling up to the parent div
                          e.stopPropagation();
                        }}
                      >
                        {item.label}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/*  users */}

          <Link
            to="/users/user"
            style={getMenuItemStyle(currentPath === "/users/user")}
            data-active={currentPath === "/users/user" ? "true" : ""}
            onMouseEnter={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "#f1f3f5";
              }
              if (collapsed) {
                const tooltip = document.createElement("div");
                tooltip.className = "custom-tooltip";
                tooltip.innerText = "Users";
                document.body.appendChild(tooltip);
                const rect = e.currentTarget.getBoundingClientRect();
                tooltip.style.left = `${rect.right + 8}px`;
                tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "";
              }
              const tooltip = document.querySelector(".custom-tooltip");
              if (tooltip) tooltip.remove();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i className="bi bi-people" style={styles.icon}></i>
              {!collapsed && <span>Users</span>}
            </div>
          </Link>




          {/*  Contact */}

          <div
            onClick={() => openUpgradeModal()}
            style={{
              ...getMenuItemStyle(false),
              color: "#adb5bd",
              cursor: "not-allowed",
              padding: "8px 16px"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f1f3f5";
              if (collapsed) {
                const tooltip = document.createElement("div");
                tooltip.className = "custom-tooltip";
                tooltip.innerText = "Contact";
                document.body.appendChild(tooltip);
                const rect = e.currentTarget.getBoundingClientRect();
                tooltip.style.left = `${rect.right + 8}px`;
                tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "";
              const tooltip = document.querySelector(".custom-tooltip");
              if (tooltip) tooltip.remove();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i className="bi bi-person" style={{ ...styles.icon, color: "#adb5bd" }}></i>
              {!collapsed && <span>Contact</span>}
            </div>
          </div>


          {/* Email */}

          <div

            onClick={() => openUpgradeModal()}
            style={{
              ...getMenuItemStyle(false),
              color: "#adb5bd",
              cursor: "not-allowed",
              padding: "8px 16px"
            }}
            data-active={currentPath === "/email/inbox" ? "true" : ""}
            onMouseEnter={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "#f1f3f5";
              }
              if (collapsed) {
                const tooltip = document.createElement("div");
                tooltip.className = "custom-tooltip";
                tooltip.innerText = "Email";
                document.body.appendChild(tooltip);
                const rect = e.currentTarget.getBoundingClientRect();
                tooltip.style.left = `${rect.right + 8}px`;
                tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "";
              }
              const tooltip = document.querySelector(".custom-tooltip");
              if (tooltip) tooltip.remove();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i className="bi bi-envelope-arrow-down" style={{ ...styles.icon, color: "#adb5bd" }}></i>
              {!collapsed && <span>Email</span>}
            </div>
          </div>

          {/* Ticket */}

          <div
            onClick={() => openUpgradeModal()}
            style={{
              ...getMenuItemStyle(false),
              color: "#adb5bd",
              cursor: "not-allowed",
              padding: "8px 16px"
            }}
            data-active={currentPath === "/ticket/lists" ? "true" : ""}
            onMouseEnter={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "#f1f3f5";
              }
              if (collapsed) {
                const tooltip = document.createElement("div");
                tooltip.className = "custom-tooltip";
                tooltip.innerText = "Ticket";
                document.body.appendChild(tooltip);
                const rect = e.currentTarget.getBoundingClientRect();
                tooltip.style.left = `${rect.right + 8}px`;
                tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "";
              }
              const tooltip = document.querySelector(".custom-tooltip");
              if (tooltip) tooltip.remove();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i className="bi bi-ticket-detailed" style={{ ...styles.icon, color: "#adb5bd" }}  ></i>
              {!collapsed && <span>Ticket</span>}
            </div>
          </div>

          {/*  leads */}

          <Link
            to="/campaign/list"
            style={getMenuItemStyle(currentPath === "/campaign/list")}
            data-active={currentPath === "/campaign/list" ? "true" : ""}
            onMouseEnter={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "#f1f3f5";
              }
              if (collapsed) {
                const tooltip = document.createElement("div");
                tooltip.className = "custom-tooltip";
                tooltip.innerText = "Leads";
                document.body.appendChild(tooltip);
                const rect = e.currentTarget.getBoundingClientRect();
                tooltip.style.left = `${rect.right + 8}px`;
                tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.dataset.active) {
                e.currentTarget.style.backgroundColor = "";
              }
              const tooltip = document.querySelector(".custom-tooltip");
              if (tooltip) tooltip.remove();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i className="bi bi-menu-up" style={styles.icon}></i>
              {!collapsed && <span>Leads</span>}
            </div>
          </Link>


          {/* chat */}

          <div>
            <div
              onClick={() => handleSubmenuToggle("chat")}
              style={getMenuItemStyle(currentPath.includes("/chat"))}
              data-active={currentPath === "/chat/chatrooms" ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Chat";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-chat" style={styles.icon}></i>
                {!collapsed && <span>Chat</span>}
              </div>
              {!collapsed && (
                <i
                  className={`bi ${submenuVisible["chat"] ? "bi-chevron-up" : "bi-chevron-down"
                    }`}
                  style={styles.chevron}
                />
              )}
            </div>

            {!collapsed && (
              <div
                style={{
                  ...styles.submenuContainer,
                  maxHeight: submenuVisible["chat"] ? "200px" : "0",
                  opacity: submenuVisible["chat"] ? 1 : 0,
                }}
              >
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Live Chat
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Chat History
                </div>
              </div>
            )}
          </div>

          {/* Social media */}


          <div>
            <div
              onClick={() => handleSubmenuToggle("socialMedia")}
              style={getMenuItemStyle(currentPath.includes("/social-media"))}
              data-active={(currentPath === "/social-media/youtube" || currentPath === "/social-media/instagram" || currentPath === "/social-media/post") ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Social Media";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <SocialMediaIcon
                  style={{ width: 20, height: 20, marginRight: 12 }}
                />
                {!collapsed && <span>Social Media</span>}
              </div>
              {!collapsed && (
                <i
                  className={`bi ${submenuVisible["socialMedia"]
                    ? "bi-chevron-up"
                    : "bi-chevron-down"
                    }`}
                  style={styles.chevron}
                />
              )}
            </div>

            {!collapsed && (
              <div
                style={{
                  ...styles.submenuContainer,
                  maxHeight: submenuVisible["socialMedia"] ? "300px" : "0",
                  opacity: submenuVisible["socialMedia"] ? 1 : 0,
                }}
              >
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Youtube
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Instagram
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Post
                </div>
              </div>
            )}
          </div>

          {/*  Analytics */}
          <div
            onClick={() => openUpgradeModal()}
            style={{
              ...styles.menuItem,
              color: "#adb5bd",
              cursor: "not-allowed",
              textDecoration: "none"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f1f3f5";
              if (collapsed) {
                const tooltip = document.createElement("div");
                tooltip.className = "custom-tooltip";
                tooltip.innerText = "Analytics";
                document.body.appendChild(tooltip);
                const rect = e.currentTarget.getBoundingClientRect();
                tooltip.style.left = `${rect.right + 8}px`;
                tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "";
              const tooltip = document.querySelector(".custom-tooltip");
              if (tooltip) tooltip.remove();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i
                className="bi bi-bar-chart-line"
                style={{ ...styles.icon, color: "#adb5bd" }}
              ></i>
              {!collapsed && <span>Analytics</span>}
            </div>
          </div>

          {/*  report */}

          <div>
            <div
              onClick={() => handleSubmenuToggle("reports")}
              style={getMenuItemStyle(currentPath.includes("/reports"))}
              data-active={(currentPath === "/reports/campaign/reports-list" || currentPath === "/reports/email/reports-list" || currentPath === "/reports/ticket/reports-list" || currentPath === "/reports/telephony/reports-list" || currentPath === "/reports/report-social-media/reports-list" || currentPath === "/reports/conversation/reports-list") ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Reports";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i
                  className="bi bi-file-earmark-bar-graph"
                  style={styles.icon}
                ></i>
                {!collapsed && <span>Reports</span>}
              </div>
              {!collapsed && (
                <i
                  className={`bi ${submenuVisible["reports"]
                    ? "bi-chevron-up"
                    : "bi-chevron-down"
                    }`}
                  style={styles.chevron}
                />
              )}
            </div>

            {!collapsed && (
              <div
                style={{
                  ...styles.submenuContainer,
                  maxHeight: submenuVisible["reports"] ? "500px" : "0",
                  opacity: submenuVisible["reports"] ? 1 : 0,
                }}
              >

                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Email
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Ticket
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Telephony
                </div>

                {planName === "Free" && (

                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                    style={{
                      ...getDropdownItemStyle(false),
                      color: "#adb5bd",
                      cursor: "not-allowed",
                      padding: "8px 16px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "";
                    }}
                  >
                    Leads
                  </div>
                )}

                {planName === "Freemium" && (

                  <Link
                    to="/reports/campaign/reports-list"
                    style={getDropdownItemStyle(
                      currentPath === "/reports/campaign/reports-list"
                    )}
                    data-active={currentPath === "/reports/campaign/reports-list" ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    Leads
                  </Link>

                )}


                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Chat
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  Social Media
                </div>

              </div>
            )}
          </div>

          {/*  Settings */}
          <div>
            <div
              onClick={() => handleSubmenuToggle("settings")}
              style={getMenuItemStyle(currentPath.includes("/settings"))}
              data-active={(currentPath === "/settings/users" || currentPath === "/settings/customer" || currentPath === "/settings/general" || currentPath === "/settings/ticket" || currentPath === "/settings/email" || currentPath === "/settings/campaign" || currentPath === "/settings/telephony/server-configuration" || currentPath === "/settings/integration" || currentPath === "/settings/youtube" || currentPath === "/settings/instagram-config" || currentPath === "/settings/instagram" || currentPath === "/settings/youtubebot" || currentPath === "/settings/website" || currentPath === "/settings/chat" || currentPath === "/settings/schedule" || currentPath === "/settings/acknowledgement") ? "true" : ""}
              onMouseEnter={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "#f1f3f5";
                }
                if (collapsed) {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerText = "Settings";
                  document.body.appendChild(tooltip);
                  const rect = e.currentTarget.getBoundingClientRect();
                  tooltip.style.left = `${rect.right + 8}px`;
                  tooltip.style.top = `${rect.top + rect.height / 2 - 10}px`;
                }
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.dataset.active) {
                  e.currentTarget.style.backgroundColor = "";
                }
                const tooltip = document.querySelector(".custom-tooltip");
                if (tooltip) tooltip.remove();
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="bi bi-sliders" style={styles.icon}></i>
                {!collapsed && <span>Settings</span>}
              </div>
              {!collapsed && (
                <i
                  className={`bi ${submenuVisible["settings"] ? "bi-chevron-up" : "bi-chevron-down"
                    }`}
                  style={styles.chevron}
                />
              )}
            </div>

            {!collapsed && (
              <div
                style={{
                  ...styles.submenuContainer,
                  maxHeight: submenuVisible["settings"] ? "800px" : "0",
                  opacity: submenuVisible["settings"] ? 1 : 0,
                }}
              >
                <Link
                  to="/settings/users"
                  style={getDropdownItemStyle(currentPath === "/settings/users")}
                  data-active={currentPath === "/settings/users" ? "true" : ""}
                  onMouseEnter={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "";
                    }
                  }}
                >
                  <i
                    className="bi bi-people"
                    style={{ ...styles.icon, fontSize: "16px" }}
                  ></i>
                  Users
                </Link>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-bag-check"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  Contact
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-sliders"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  General
                </div>
                <div

                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-ticket-detailed"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  Ticket
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-envelope"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  Email
                </div>


                <Link
                  to="/settings/campaign"
                  style={getDropdownItemStyle(currentPath === "/settings/campaign")}
                  data-active={currentPath === "/settings/campaign" ? "true" : ""}
                  onMouseEnter={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!e.currentTarget.dataset.active) {
                      e.currentTarget.style.backgroundColor = "";
                    }
                  }}
                >
                  <i
                    className="bi bi-menu-up"
                    style={{ ...styles.icon, fontSize: "16px" }}
                  ></i>
                  Leads
                </Link>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-telephone"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  Telephony
                </div>

                {/* Social Media */}
                <div>
                  <div
                    onClick={() => handleSubmenuToggle("settings-socialmedia")}
                    style={{
                      ...getDropdownItemStyle(
                        currentPath.includes("/settings/integration") ||
                        currentPath.includes("/settings/youtube") ||
                        currentPath.includes("/settings/instagram-config") ||
                        currentPath.includes("/settings/website") ||
                        currentPath.includes("/settings/instagram") ||
                        currentPath.includes("/settings/youtubebot")
                      ),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    data-active={(currentPath === "/settings/integration" || currentPath === "/settings/youtube" || currentPath === "/settings/instagram-config" || currentPath === "/settings/instagram" || currentPath === "/settings/youtubebot" || currentPath === "/settings/website") ? "true" : ""}
                    onMouseEnter={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.currentTarget.dataset.active) {
                        e.currentTarget.style.backgroundColor = "";
                      }
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i
                        className="bi bi-share"
                        style={{ ...styles.icon, fontSize: "16px" }}
                      ></i>
                      Social Media
                    </div>
                    <i
                      className={`bi ${submenuVisible["settings-socialmedia"]
                        ? "bi-chevron-up"
                        : "bi-chevron-down"
                        }`}
                      style={{ ...styles.chevron, fontSize: "12px" }}
                    />
                  </div>

                  <div
                    style={{
                      paddingLeft: "20px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                      maxHeight: submenuVisible["settings-socialmedia"]
                        ? "500px"
                        : "0",
                      opacity: submenuVisible["settings-socialmedia"] ? 1 : 0,
                    }}
                  >
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openUpgradeModal();
                      }}
                      style={{
                        ...getDropdownItemStyle(false),
                        color: "#adb5bd",
                        cursor: "not-allowed",
                        padding: "8px 16px"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "";
                      }}
                    >
                      <i
                        className="bi bi-gear"
                        style={{ ...styles.icon, color: "#adb5bd", fontSize: "14px" }}
                      ></i>
                      WhatsApp configuration
                    </div>
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openUpgradeModal();
                      }}
                      style={{
                        ...getDropdownItemStyle(false),
                        color: "#adb5bd",
                        cursor: "not-allowed",
                        padding: "8px 16px"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "";
                      }}
                    >
                      <i
                        className="bi bi-calendar-event"
                        style={{ ...styles.icon, color: "#adb5bd", fontSize: "14px" }}
                      ></i>
                      Youtube configuration
                    </div>
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openUpgradeModal();
                      }}
                      style={{
                        ...getDropdownItemStyle(false),
                        color: "#adb5bd",
                        cursor: "not-allowed",
                        padding: "8px 16px"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f1f3f5";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "";
                      }}
                    >
                      <i
                        className="bi bi-instagram"
                        style={{ ...styles.icon, color: "#adb5bd", fontSize: "14px" }}
                      ></i>
                      Instagram configuration
                    </div>

                    {/* Bot configuration */}
                    <div>
                      <div
                        onClick={() => handleSubmenuToggle("settings-botconfig")}
                        style={{
                          ...getDropdownItemStyle(
                            currentPath === "/settings/instagram" ||
                            currentPath.includes("/settings/website") ||
                            currentPath.includes("/settings/youtubebot")
                          ),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        data-active={(currentPath === "/settings/instagram" || currentPath === "/settings/youtubebot" || currentPath === "/settings/website") ? "true" : ""}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.dataset.active) {
                            e.currentTarget.style.backgroundColor = "";
                          }
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            className="bi bi-robot"
                            style={{ ...styles.icon, fontSize: "14px" }}
                          ></i>
                          Bot configuration
                        </div>
                        <i
                          className={`bi ${submenuVisible["settings-botconfig"]
                            ? "bi-chevron-up"
                            : "bi-chevron-down"
                            }`}
                          style={{ ...styles.chevron, fontSize: "12px" }}
                        />
                      </div>

                      <div
                        style={{
                          paddingLeft: "20px",
                          overflow: "hidden",
                          transition: "all 0.3s ease",
                          maxHeight: submenuVisible["settings-botconfig"]
                            ? "200px"
                            : "0",
                          opacity: submenuVisible["settings-botconfig"] ? 1 : 0,
                        }}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          style={{
                            ...getDropdownItemStyle(false),
                            color: "#adb5bd",
                            cursor: "not-allowed",
                            padding: "8px 16px"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "";
                          }}
                        >
                          <i
                            className="bi bi-instagram"
                            style={{ ...styles.icon, color: "#adb5bd", fontSize: "12px" }}
                          ></i>
                          Instagram
                        </div>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          style={{
                            ...getDropdownItemStyle(false),
                            color: "#adb5bd",
                            cursor: "not-allowed",
                            padding: "8px 16px"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "";
                          }}
                        >
                          <i
                            className="bi bi-globe"
                            style={{ ...styles.icon, color: "#adb5bd", fontSize: "12px" }}
                          ></i>
                          Website
                        </div>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          style={{
                            ...getDropdownItemStyle(false),
                            color: "#adb5bd",
                            cursor: "not-allowed",
                            padding: "8px 16px"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f1f3f5";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "";
                          }}
                        >
                          <i
                            className="bi bi-youtube"
                            style={{ ...styles.icon, color: "#adb5bd", fontSize: "12px" }}
                          ></i>
                          Youtube
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {(localStorage.getItem("user_role") === "admin") &&
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                    style={{
                      ...getDropdownItemStyle(false),
                      color: "#adb5bd",
                      cursor: "not-allowed",
                      padding: "8px 16px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f1f3f5";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "";
                    }}
                  >
                    <i
                      className="bi bi-chat-text"
                      style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                    ></i>
                    Chat
                  </div>
                }
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-clock"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  Schedule report
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openUpgradeModal();
                  }}
                  style={{
                    ...getDropdownItemStyle(false),
                    color: "#adb5bd",
                    cursor: "not-allowed",
                    padding: "8px 16px"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f3f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <i
                    className="bi bi-check-circle"
                    style={{ ...styles.icon, color: "#adb5bd", fontSize: "16px" }}
                  ></i>
                  Knowledge base
                </div>
              </div>
            )}
          </div>

        </>
      )}
    </div>
  );
};

export default MobileHeaderContents;